module.exports = __webpack_public_path__ + "f1baedfe7ae0a8eb6fa4d273586626f1.png";